import styled from "@emotion/styled";
import { Box, Button, Card, CardActionArea, CardContent, Typography, Stack } from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import Chip from "@mui/material/Chip";

export const ProductCard = styled(Card)({
	display: "flex",
	width: "100%",
	maxWidth: 473,
	flexDirection: "column"
});

export const ProductChipStack = styled(Stack)({
	width: "95%",
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-end",
	padding: "4px",
	minHeight: 32
});

export const ProductCardActionArea = styled(CardActionArea)({
	textAlign: "left"
});

// Use a plain img so src/alt are valid and strongly typed
export const ProductCardMedia = styled("img")({
	width: "100%",
	height: 200,
	objectFit: "contain",
	display: "block"
});

export const ProductCardContent = styled(CardContent)({
	textAlign: "center",
	paddingBottom: 0,
	marginBottom: 0
});

export const ProductCardSKUTypography = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.secondary
}));

export const ProductCardPriceTypography = styled(Typography)({
	gridColumn: 2,
	textAlign: "center"
});

export const ProductCardBox = styled(Box)({
	display: "grid",
	gridTemplateColumns: "1fr auto 1fr",
	alignItems: "center",
	minHeight: 85,
	marginTop: "auto"
});

export const CartButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	padding: "8px 24px",
	display: "flex",
	flexDirection: "column",
	marginLeft: "auto"
}));

export const ShoppingCartButton = styled(AddShoppingCartIcon)({
	transform: "scaleX(-1)"
});

export const LimitedStockChip = styled(Chip)({
	color: "var(--cwg-blue-900)",
	borderColor: "var(--cwg-blue-900)"
});

export const BackorderedChip = styled(Chip)({
	color: "var(--orange-500)",
	borderColor: "var(--orange-500)"
});

export const CartChip = styled(Chip)({
	backgroundColor: "var(--light-blue-500)",
	color: "#fff"
});
